/**
 * Returns the model representation of a plain object, or if a model is passed
 * it will be returned unaltered.
 *
 * Examples:
 *   wrapModel({id, label,...}, Backbone.Model)
 *   wrapModel(modelInstance, Backbone.Model)
 *
 * @param {Object|Backbone.Model} object
 * @param {Backbone.Model} constructor
 * @param {Object} [options] - Optional options to pass to the constructor
 * @return {Backbone.Model} of whatever type was provided for
 * <code>constructor</code> when <code>object</code> is defined. If
 * <code>object</code> is null or undefined, it will be returned as is.
 */
function wrapModel(object, constructor,
	options) {
	// Return the object unchanged if it is null or undefined
	if (object === null || object === undefined) {
		return object
	}
	return object instanceof constructor ? object : new constructor(object, options)
}
export default wrapModel

wrapModel.__filename__ = 'components/wrap-model.js'
